var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlickr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    height: "256px",
    width: "256px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2449",
    y2: 425.4,
    gradientUnits: "userSpaceOnUse",
    x2: -395.85,
    gradientTransform: "matrix(-.59146 0 0 .59146 210.02 142.23)",
    y1: 274.71,
    x1: -344.15
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2557",
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2559",
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-373.64 -318.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect1942",
    ry: 35.488,
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 0.5,
    fill: "#ececeb",
    fillRule: "evenodd",
    rx: 35.488,
    transform: "scale(-1,1)",
    width: 235.01,
    height: 234.99,
    y: 328.85,
    x: -619.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1950",
    d: "m557.06 338.9h-110.83c-29.34 0-52.96 23.8-52.96 53.38v108.13c0.95 23.08 4.6 8.49 11.56-17.08 8.08-29.71 34.39-55.68 66.44-75.14 24.46-14.86 51.84-24.34 101.68-25.25 28.27-0.51 25.77-36.68-15.89-44.04z",
    fillRule: "evenodd",
    fill: "url(#linearGradient2449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4776",
    d: "m115.71 124.57c0 22.289-16.629 40.357-37.143 40.357-20.513 0-37.143-18.069-37.143-40.357 0-22.289 16.629-40.357 37.143-40.357 20.513 0 37.143 18.069 37.143 40.357z",
    transform: "translate(373.64 318.34)",
    fill: "#0059d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4778",
    d: "m215.71 127.61c0 21.993-17.109 39.821-38.214 39.821s-38.214-17.829-38.214-39.821c0-21.993 17.109-39.821 38.214-39.821s38.214 17.829 38.214 39.821z",
    transform: "translate(368.64 314.77)",
    fill: "#da1593"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlickr);
export default __webpack_public_path__ + "static/media/flickr.20cc7599691cf549cf3d0ca8e6f49fcf.svg";
export { ForwardRef as ReactComponent };